import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const name = 'punch-records'

const initialState = {
  list: null,
  calendarEvents: null,
  leaveRecords: null,
  punchRequests: null,
  recordDetails: null,
  loading: false,
}

//Self API for non-admin users
export const searchSelf = createApiAction('leave/punch-records/search', client.search('/api/leave/punch-records'))
export const get = createApiAction('leave/punch-records/get', client.retrieve(`/api/leave/punch-records/retrieve`))
export const save = createApiAction('leave/punch-records/save', client.save('/api/leave/punch-records'))
export const destroy = createApiAction('leave/punch-records/delete', client.destroy('/api/leave/punch-records/:id'))

//Admin API for admin users
export const searchSelectedStaff = createApiAction('leave/punch-records/searchSelectedStaff', client.search('/api/leave/punch-records/staff/:personId'))
export const getSelectedStaff = createApiAction('leave/punch-records/getSelectedStaff', client.retrieve('/api/leave/punch-records/staff/:personId/retrieve'))
export const saveSelectedStaff = createApiAction('leave/punch-records/saveSelectedStaff', client.save('/api/leave/punch-records/staff/:personId'))
export const destroySelectedStaff = createApiAction('leave/punch-records/destroySelectedStaff', client.destroy('/api/leave/punch-records/staff/:personId'))


const syncListOnSave = (state, oldRecord, newEventId) => {
  if (!state.list || !oldRecord || !newEventId) return
  const newEVENTID = newEventId.toUpperCase()
  if (oldRecord.EVENTID === newEVENTID) return
  const date = oldRecord.LOCAL_TIMESTAMP?.slice(0, 10)
  if (!date) return
  const formattedTime = dayjs.utc(oldRecord.LOCAL_TIMESTAMP).format('hh:mm:ss A')
  const anotherOfSameType = state.recordDetails?.dailyPunchRecords?.some(
    r => r.Id !== oldRecord.Id && r.EVENTID === oldRecord.EVENTID
  )
  state.list = state.list.map(item => {
    if (item.PunchDate !== date) return item
    const updated = { ...item }
    if (!anotherOfSameType) {
      if (oldRecord.EVENTID === 'IN') updated.PunchIn = null
      if (oldRecord.EVENTID === 'OUT') updated.PunchOut = null
    }
    if (newEVENTID === 'IN' && !updated.PunchIn) updated.PunchIn = formattedTime
    if (newEVENTID === 'OUT' && !updated.PunchOut) updated.PunchOut = formattedTime
    return updated
  })
}

const update = (state, action) => {
  const found = state.list?.find(rec => rec.id === action.payload.id)
  state.list = found
    ? state.list.map(item => (found.id === item.id ? action.payload : item))
    : [...state.list, action.payload]
}

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    addPunchRequest: (state, action) => {
      state.punchRequests = [...(state.punchRequests ?? []), action.payload]
    },
  },
  extraReducers(builder) {
    builder
      .addCase(searchSelf.pending, (state) => {
        state.loading = true
      })
      .addCase(searchSelf.fulfilled, (state, action) => {
        state.list = action.payload.punchRecords?.sort((a, b) => new Date(a.PunchDate) - new Date(b.PunchDate))
        state.calendarEvents = action.payload.calendarEvents ?? []
        state.leaveRecords = action.payload.leaveRecords ?? []
        state.punchRequests = action.payload.punchRequests ?? []
        state.loading = false
      })
      .addCase(searchSelectedStaff.pending, (state) => {
        state.loading = true
      })
      .addCase(searchSelectedStaff.fulfilled, (state, action) => {
        state.list = action.payload.punchRecords?.sort((a, b) => new Date(a.PunchDate) - new Date(b.PunchDate))
        state.calendarEvents = action.payload.calendarEvents ?? []
        state.leaveRecords = action.payload.leaveRecords ?? []
        state.punchRequests = action.payload.punchRequests ?? []
        state.loading = false
      })
      .addCase(get.fulfilled, (state, action) => {
        if (action.meta.arg?.date) {
          state.recordDetails = action.payload
        } else {
          update(state, action)
        }
      })
      .addCase(getSelectedStaff.fulfilled, (state, action) => {
        state.recordDetails = action.payload
      })
      .addCase(save.fulfilled, (state, action) => {
        if (state.recordDetails?.dailyPunchRecords) {
          const { id, eventId } = action.meta.arg
          const oldRecord = state.recordDetails.dailyPunchRecords.find(item => item.Id === id)
          state.recordDetails.dailyPunchRecords = state.recordDetails.dailyPunchRecords.map(
            item => item.Id === id ? { ...item, ...action.payload } : item
          )
          syncListOnSave(state, oldRecord, eventId)
        }
      })
      .addCase(saveSelectedStaff.fulfilled, (state, action) => {
        if (state.recordDetails?.dailyPunchRecords) {
          const { id, eventId } = action.meta.arg
          const oldRecord = state.recordDetails.dailyPunchRecords.find(item => item.Id === id)
          state.recordDetails.dailyPunchRecords = state.recordDetails.dailyPunchRecords.map(
            item => item.Id === id ? { ...item, ...action.payload } : item
          )
          syncListOnSave(state, oldRecord, eventId)
        }
      })
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list?.filter(item => item.id !== action.payload.id)
        state.allItems = state.allItems?.filter(item => item.id !== action.payload.id)
      })
  },
})
export const { addPunchRequest } = sessionSlice.actions

export default sessionSlice.reducer
